module.exports = __webpack_public_path__ + "img/bumen.7d7cd4f4.png";